<div class="justup-dialog">
  <vl-header-dialog (close)="dialogRef.close()">
    {{ data.title || "Confirmation" }}
  </vl-header-dialog>

  <div class="justup-dialog-content">
    @if (data.message) {
      <div class="message-row">
        {{ data.message }}
      </div>
    }

    @if (data.articles?.length) {
      <div class="articles-list">
        @for (a of data.articles; track a.articleId) {
          <div class="article-item">
            <span class="article-item__name">{{ a.denomination ?? a.articleId }}</span>
            @if (a.code) {
              <span class="article-item__code">{{ a.code }}</span>
            }
          </div>
        }
      </div>
    }

    @if (autoDelayMs > 0) {
      <div class="auto-row">
        <span class="countdown">{{ countdownSec }} s</span>
        <div class="progress-track">
          <div class="progress-bar bg-primary" [style.width.%]="progressPct"></div>
        </div>
      </div>
    }
  </div>

  <div class="justup-dialog-footer">
    <div class="flex-row ml-auto gap-12">
      @if (data.buttons) {
        @if (data.buttons.no) {
          <vl-big-button
            data-testid="btn-cancel-dialog"
            type="fit"
            color="error"
            (action)="dialogRef.close(false)"
            [text]="data.buttons.no"
          >
          </vl-big-button>
        }
        <vl-big-button
          data-testid="btn-confirm-dialog"
          type="fit"
          color="primary"
          (action)="dialogRef.close(true)"
          [text]="data.buttons.yes"
        >
        </vl-big-button>
      } @else {
        <vl-big-button
          data-testid="btn-cancel-dialog"
          type="fit"
          color="error"
          (action)="onCancel()"
          [text]="data.cancelText ?? ('button.cancel' | trans)"
        >
        </vl-big-button>
        <vl-big-button
          data-testid="btn-confirm-dialog"
          type="fit"
          color="primary"
          (action)="onConfirm()"
          [text]="data.confirmText ?? ('button.confirm' | trans)"
        >
        </vl-big-button>
      }

    </div>
  </div>
</div>
